<div class="employment-wrap">
  <form [formGroup]="salariedFormGroup" >
    <!-- Scenario 1 -- Salaried for Individual/Guardian/Sponsor -->
    <div class="cus-row" *ngIf="isSalaried">
      <div class="col-12 form-group" *ngIf="isStudentMainApplicant">
        <div class="employment-tag">
          <svg class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g id="Tick">
              <circle id="Ellipse 6167" cx="10" cy="10" r="10" fill="#17151C" />
              <path id="Vector"
                d="M8.51944 13.6972C8.29722 13.6972 8.08611 13.6083 7.93056 13.4527L5.24167 10.7638C4.91944 10.4416 4.91944 9.90829 5.24167 9.58607C5.56389 9.26385 6.09722 9.26385 6.41944 9.58607L8.51944 11.6861L13.2972 6.90829C13.6194 6.58607 14.1528 6.58607 14.475 6.90829C14.7972 7.23051 14.7972 7.76385 14.475 8.08607L9.10833 13.4527C8.95278 13.6083 8.74167 13.6972 8.51944 13.6972Z"
                fill="#10D7EE" />
            </g>
          </svg> Salaried
        </div>
      </div>
      <div class="col-3 form-group" *ngIf="!isStudentMainApplicant"> <!-- For Guardian/Sponsor flow -->
        <label class="form-label">Select Employment status</label>
        <div class="radio-outer">
          <div class="cus-check round" *ngFor="let desig of empDesignations">
            <input class="input-check" (click)="toggleEmpType(desig.id)" type="radio" id="employment_status_{{desig.id}}"
              name="employment_status_radio" [checked]="desig.id === employmentStatus" />
            <label for="employment_status_{{desig.id}}">{{desig.value}}</label>
          </div>
        </div>
      </div>
      <div class="col-3 form-group emp-drop input-check">
        <label class="form-label">Enter company name</label>
        <p-autoComplete formControlName="companyName" [suggestions]="suggestions" field="companyName"
          (completeMethod)="search()" placeholder="Enter Name"></p-autoComplete>
        <!-- <input class="cus-input" type="text" placeholder="Enter Name" formControlName="companyName"/> -->
        <span class="err-text" *ngIf="salariedFormGroup.get('companyName')?.hasError('required') && (salariedFormGroup.get('companyName')?.dirty)">Kindly fill this field</span>

      </div>
      <div class="col-3 form-group">
        <label class="form-label">Enter net income per month</label>
        <input class="cus-input" type="text" placeholder="Enter Amount" formControlName="netIncome" (input)="onInput($event,salariedFormGroup,'netIncome')" maxlength="14" />
        <span class="err-text" *ngIf="salariedFormGroup.get('netIncome')?.hasError('required') && (salariedFormGroup.get('netIncome')?.dirty)">Kindly fill this field</span>
        <!-- <span class="err-text" *ngIf="salariedFormGroup.get('netIncome')?.hasError('required')">Kindly fill this field</span> -->
        <span class="err-text" *ngIf="salariedFormGroup.get('netIncome')?.hasError('pattern') && !salariedFormGroup.get('netIncome')?.hasError('required')">Please enter a valid number</span>
      </div>
      <!-- <div class="col-6 form-group">
        <label class="form-label">Select total work experience</label>
        <div class="box-select">
          <div class="select-item" *ngFor="let option of workExperienceOptions"
            [class.selected]="salariedFormGroup.get('workExperience')?.value == option.id"
            (click)="updateWorkExperience(option.id)">
            {{ option.value }}
          </div>
        </div>
      </div> -->
      <div class="col-3 form-group">
        <label class="form-label">Select total work experience</label>
        <div class="cus-dropdown" (click)="openDrop('work_exp')">
          <input class="cus-input" type="text" placeholder="Select Category" [(ngModel)]="selectedExp" [ngModelOptions]="{standalone: true}"
           readonly />
          <div id="work_exp" class="drop-content">
            <div class="drop-item" *ngFor="let option of workExperienceOptions"
            (click)="updateWorkExperience(option)">{{option.value}}</div>
          </div>
        </div>
      </div>
    </div>
  </form>
    <form [formGroup]="selfEmpFormGroup">
    <!-- Scenario 1 -- Self Employed Individual/Guardian/Sponsor-->
    <div class="cus-row" *ngIf="!isSalaried">
      <div class="col-12 form-group" *ngIf="isStudentMainApplicant">
        <div class="employment-tag">
          <svg class="icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g id="Tick">
              <circle id="Ellipse 6167" cx="10" cy="10" r="10" fill="#17151C" />
              <path id="Vector"
                d="M8.51944 13.6972C8.29722 13.6972 8.08611 13.6083 7.93056 13.4527L5.24167 10.7638C4.91944 10.4416 4.91944 9.90829 5.24167 9.58607C5.56389 9.26385 6.09722 9.26385 6.41944 9.58607L8.51944 11.6861L13.2972 6.90829C13.6194 6.58607 14.1528 6.58607 14.475 6.90829C14.7972 7.23051 14.7972 7.76385 14.475 8.08607L9.10833 13.4527C8.95278 13.6083 8.74167 13.6972 8.51944 13.6972Z"
                fill="#10D7EE" />
            </g>
          </svg> Self-Employed
        </div>
      </div>
      <div class="col-3 form-group" *ngIf="!isStudentMainApplicant"> <!-- For Guardian/Sponsor flow -->
        <label class="form-label">Select Employment status</label>
        <div class="radio-outer">
          <div class="cus-check round" *ngFor="let desig of empDesignations">
            <input class="input-check" (click)="toggleEmpType(desig.id)" type="radio" id="employment_status_{{desig.id}}"
              name="employment_status_radio" [checked]="desig.id === employmentStatus" />
            <label for="employment_status_{{desig.id}}">{{desig.value}}</label>
          </div>
        </div>
      </div>
      <div class="col-3 form-group">
        <label class="form-label">Select sub category</label>
        <div class="cus-dropdown" (click)="openDrop('employment_category_drop')">
          <input class="cus-input" type="text" placeholder="Select Category" formControlName="empBusiness"
            [(ngModel)]="empBusinessName" readonly />
          <div id="employment_category_drop" class="drop-content">
            <div class="drop-item" *ngFor="let empBusiness of employeeBusinessList"
              (click)='getEmpBusiness(empBusiness.id,empBusiness.value)'>{{empBusiness.value}}</div>
          </div>
        </div>
      </div>
      <div class="col-3 form-group">
        <label class="form-label">Enter your monthly sales</label>
        <input class="cus-input" type="text" formControlName="monthlySales" placeholder="Enter Amount" (input)="onInput($event,selfEmpFormGroup,'monthlySales')" maxlength="14"/>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('monthlySales')?.hasError('pattern') && !selfEmpFormGroup.get('monthlySales')?.hasError('required')">Please enter a valid number</span>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('monthlySales')?.hasError('required')&&
         (selfEmpFormGroup.get('monthlySales')?.dirty)">Kindly fill this field</span>
      </div>
      <div class="col-3 form-group">
        <label class="form-label">Enter your net profits per month</label>
        <input class="cus-input" formControlName="netMonthlyProfit" type="text" placeholder="Enter Amount" maxlength="14" (input)="netMonthlyProfitValidator($event,selfEmpFormGroup,'netMonthlyProfit')"/>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('netMonthlyProfit')?.hasError('required') &&
        (selfEmpFormGroup.get('netMonthlyProfit')?.dirty)">Kindly fill this field</span>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('netMonthlyProfit')?.hasError('pattern') && !selfEmpFormGroup.get('netMonthlyProfit')?.hasError('required')">Please enter a valid number</span>
        <span class="err-text" *ngIf="netMonthlyProfitGreaterThanGross">Net profit should be less than gross</span>
      </div>
      <div class="col-3 form-group">
        <label class="form-label">Enter your gross receipts per month</label>
        <input class="cus-input" type="text" formControlName="gross" placeholder="Enter Amount" maxlength="14" (input)="netMonthlyProfitValidator($event,selfEmpFormGroup,'gross')"/>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('gross')?.hasError('required') &&
        (selfEmpFormGroup.get('gross')?.dirty)">Kindly fill this field</span>
        <span class="err-text" *ngIf="selfEmpFormGroup.get('gross')?.hasError('pattern') && !selfEmpFormGroup.get('gross')?.hasError('required')">Please enter a valid number</span>

      </div>
      <!-- <div class="col-6 form-group exp-field">
        <label class="form-label">Select total work experience</label>
        <div class="box-select">
          <div class="select-item" *ngFor="let option of workExperienceOptions"
            [class.selected]="selfEmpFormGroup.get('workExperience')?.value == option.id"
            (click)="updateWorkExperience(option.id)">
            {{ option.value }}
          </div>
        </div>
      </div> -->
      <div class="col-3 form-group">
        <label class="form-label">Select total work experience</label>
        <div class="cus-dropdown" (click)="openDrop('work_exp')">
          <input class="cus-input" type="text" placeholder="Select Category" [(ngModel)]="selectedExp" 
          [ngModelOptions]="{standalone: true}" readonly/>
          <div id="work_exp" class="drop-content">
            <div class="drop-item" *ngFor="let option of workExperienceOptions"
            (click)="updateWorkExperience(option)">{{option.value}}</div>
          </div>
        </div>
      </div>
    </div>
    </form>

  <!-- Address Details -->
  <form [formGroup]="addressDetailFormGroup">
    <div class="address-sec">
      <div class="addr-title">
        <img src="assets/images/icons/address_head.svg" alt="Icon" />Current Address Details
      </div>
      <div class="cus-row">
        <div class="col-3 form-group">
          <label class="form-label">Address Line 1 <span class="mandatory">*</span></label>
          <input class="cus-input" formControlName="addLine1" type="text" placeholder="Enter Address" />
        <span class="err-text" *ngIf="addressDetailFormGroup.get('addLine1')?.hasError('required') &&
        (addressDetailFormGroup.get('addLine1')?.dirty)">Kindly fill this field</span>

        </div>
        <div class="col-3 form-group">
          <label class="form-label">Address Line 2</label>
          <input class="cus-input" formControlName="addLine2" type="text" placeholder="Enter Address" />
        </div>
        <div class="col-3 form-group">
          <label class="form-label">Area</label>
          <input class="cus-input" formControlName="area" type="text" placeholder="Enter Area" />
        </div>
        <div class="col-3 form-group">
          <label class="form-label">Pincode <span class="mandatory">*</span></label>
          <input class="cus-input" formControlName="pinCode" type="text" placeholder="Enter Pincode"
            (input)="getPincodeDetails()" maxlength="6"/>
          <span class="err-text" *ngIf="addressDetailFormGroup.get('pinCode')?.hasError('required') &&
          (addressDetailFormGroup.get('pinCode')?.dirty)">Kindly fill this field</span>
          <span class="err-text" *ngIf="addressDetailFormGroup.get('pinCode')?.hasError('pattern')">PIN Code should be a 6-digit
            number.</span>

          <div class="pincode-place" *ngIf="userRegion.length && userRegion != 'Invalid'">
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
              <path
                d="M16.5432 6.74109C15.7468 3.2371 12.6903 1.65955 10.0054 1.65955C10.0054 1.65955 10.0054 1.65955 9.99784 1.65955C7.32055 1.65955 4.25646 3.22951 3.4601 6.7335C2.57273 10.647 4.96939 13.9614 7.13853 16.0471C7.94247 16.8207 8.97395 17.2075 10.0054 17.2075C11.0369 17.2075 12.0684 16.8207 12.8647 16.0471C15.0339 13.9614 17.4305 10.6546 16.5432 6.74109ZM10.0054 10.5409C8.68574 10.5409 7.61635 9.47147 7.61635 8.15178C7.61635 6.8321 8.68574 5.7627 10.0054 5.7627C11.3251 5.7627 12.3945 6.8321 12.3945 8.15178C12.3945 9.47147 11.3251 10.5409 10.0054 10.5409Z"
                fill="#17151C" />
            </svg>
            {{userRegion}}
          </div>

          <span class="err-text" *ngIf="userRegion == 'Invalid'">Invalid Pincode</span>
        </div>
      </div>
    </div>
  </form>

  <!-- <div class="page-action">
    <button class="btn-primary" [class.disable] = !checkValidation() (click)="saveEmpDetals()">Continue</button>
  </div> -->
</div>
